import { createFileRoute } from "@tanstack/react-router";

import { AdminApplicationDetailPage } from "@/features/admin/application-detail-page";
import { applicationDetailQueryOptions } from "@/features/applications/queries";
import { applicantNameCrumb } from "@/lib/crumb-resolvers";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute(
  "/_authenticated/admin/cases/$id/applications/$appId",
)({
  staticData: { crumb: applicantNameCrumb() },
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      applicationDetailQueryOptions(params.appId),
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { appId } = Route.useParams();
  return <AdminApplicationDetailPage appId={appId} />;
}
